module.exports=function(scope){ return `curl -X GET "https://your.internal.zoomserver.instance.url/status"
`};


// WEBPACK FOOTER //
// ./src/resources/code/restsdk-v2/bash/test-connection.bash.tpl